import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Idialog } from './type';
import { Box, Typography } from '@mui/material';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { useTranslation } from 'react-i18next';

export default function DialogAction(props: Idialog) {
  const {
    open, 
    handleClose,
    title,
    content,
    onAccept,
    fullWidth=false,
    disableAcceptButton=false,
    mode,
    ...rest
  } = props;

  const { t } = useTranslation();
  return (
    <>
      <Dialog
        fullWidth={fullWidth}
        disablePortal
        open={open}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
        {...rest}
      >
        {title
          ? <DialogTitle id='alert-dialog-title' sx={{ textAlign: 'left' }}>
            <Typography variant='h3'>{String(title)}</Typography>
          </DialogTitle>
          : null
        }
        <DialogContent dividers={props.scroll === 'paper'} >
          {mode === 'delete'
            ? <Box mb={3}>
              <Box display='flex' justifyContent='center' 
                mb={1}>
                <ReportProblemIcon fontSize='large' color='error'
                  sx={{ fontSize: '120px'}}/>
              </Box>
              <Typography variant='h3' sx={{ display: 'flex', justifyContent: 'center'}}>
                Είστε Σίγουρος/η;
              </Typography>
            </Box>
            : null
          }
          {content}
        </DialogContent>
        {mode === 'info'
          ? null
          : <DialogActions>
            <Button onClick={handleClose} 
              color={mode === 'delete'
                ? 'error'
                : 'primary'
              }>{t('Ακύρωση')}</Button>
            <Button color={mode === 'delete'
              ? 'error'
              : 'primary'} 
            variant='contained'
            onClick={onAccept}
            disabled={disableAcceptButton} autoFocus >
              {mode === 'delete'
                ? t('Διαγραφή')
                : t('Επιβεβαίωση')
              }
            </Button>
          </DialogActions>
        }
      </Dialog>
    </>
  );
}
